import React from "react";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useLocation } from "react-router-dom";
import { Logo } from "./logo";
import { Item, Menu } from "./menu";
import { User } from "./user";
import { UserGuideModal } from "./user-guides-modal";
import { useDispatch } from "react-redux";
import { toggleFlag } from "@store";

const useStyles = makeStyles({
  header: {
    boxShadow: "0 .75rem .75rem -.75rem rgba(0, 0, 0, .25)",
  },
});

export const Header: React.FC = () => {
  const classNames = useStyles();
  const storeDispatch = useDispatch();
  const location = useLocation<{ error?: string }>();
  const pathname_login = location.pathname.split("/")[1];

  return pathname_login !== "login" && location?.state?.error !== "404" ? (
    <Box
      component="header"
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
      role="banner"
      p={2}
      mx={-1}
      className={classNames.header}
    >
      <Logo />
      <Menu>
        <Item
          path="#user-guide"
          onClick={(event) => {
            event.preventDefault();
            storeDispatch(toggleFlag("USER_GUIDE_MODAL_OPEN", true));
          }}
        >
          User Guide
        </Item>
        <Item path="/dashboard">Dashboard</Item>
        <Item path="/dashboard/drafts">Drafts</Item>
        <Item path="/feedback">Send Feedback</Item>
        <Item path="/release-notes">Release Notes</Item>
        <Item path="/announcements">Announcements</Item>
        <Item
          path="#settings"
          onClick={(event) => {
            event.preventDefault();
            storeDispatch(toggleFlag("SETTINGS_MODAL_OPEN", true));
          }}
        >
          User Settings
        </Item>
      </Menu>
      <User />
      <UserGuideModal
        closeModal={() => {
          storeDispatch(toggleFlag("USER_GUIDE_MODAL_OPEN", false));
        }}
      />
    </Box>
  ) : null;
};
